import type {
  FlowInstanceMemberAccessListResponse,
  IssueMemberLinkResponse,
  RevokeMemberLinkResponse,
  SendMemberInviteRequest,
  SendMemberInviteResponse,
} from "@repo/shared/types";
import { del, get, post } from "../_client";

const BASE = "/internal/flow-instances";

/** QL-505 — the current answering parties (QL-654: group members, or 2+ representatives) + their link status. */
export function getMemberAccess(instanceId: string) {
  return get<FlowInstanceMemberAccessListResponse>(`${BASE}/${instanceId}/member-access`);
}

/** Issue (or refresh) one member's link. */
export function issueMemberLink(instanceId: string, subjectId: string) {
  return post<IssueMemberLinkResponse>(`${BASE}/${instanceId}/member-access/${subjectId}`);
}

/** Revoke one member's link. */
export function revokeMemberLink(instanceId: string, subjectId: string) {
  return del<RevokeMemberLinkResponse>(`${BASE}/${instanceId}/member-access/${subjectId}`);
}

/** Send the member's link by e-mail or SMS. */
export function sendMemberInvite(
  instanceId: string,
  subjectId: string,
  channel: SendMemberInviteRequest["channel"],
) {
  return post<SendMemberInviteResponse>(`${BASE}/${instanceId}/member-access/${subjectId}/invite`, {
    channel,
  } satisfies SendMemberInviteRequest);
}
